import React from 'react';
import { SETTING_TYPES } from 'shared/constants/settings';
import { renderBool } from 'components/Table/renderers';
import SurveyGroupSelect from 'components/SurveyGroupSelect';
import { Space } from 'antd';
import CurrencyFormat from 'components/CurrencyFormat';
import { FormattedNumber } from 'react-intl';

const { BOOLEAN, NUMBER, ARRAY, SURVEY_GROUP_ID, PRICE } = SETTING_TYPES;

const SettingValue = ({ value, setting }) => {
  if (value == null) {
    return <em>Empty</em>;
  }

  switch (setting?.type) {
    case BOOLEAN:
      return renderBool(value);
    case NUMBER:
      if (value === '-1' || value === -1) {
        return <em>Unlimited</em>;
      }
      return <FormattedNumber value={value} />;
    case SURVEY_GROUP_ID:
      return <SurveyGroupSelect value={value} {...setting.inputProps} disabled />;
    case ARRAY:
      return (
        <>
          {value ? value.length : '0'}
          {' '}
          records
        </>
      );
    case PRICE:
      return (
        <Space>
          {value?.SEK && <CurrencyFormat currency="SEK" value={value.SEK} />}
          {value?.EUR && <CurrencyFormat currency="EUR" value={value.EUR} />}
          {value?.USD && <CurrencyFormat currency="USD" value={value.USD} />}
        </Space>
      );
    default:
      return value;
  }
};

export default SettingValue;
